




































































































































































  import { Component, Vue } from "vue-property-decorator";
  import CustomTable from "@/components/table.vue";
  import MemberApi from "@/api/admin/member";
  import { AdminModel, MemberModel, BannerModel, PaginationModel } from "@/api/types";
  import { AdminApi } from "@/api/admin";
  import AuthApi from "@/api/auth";
  import Encrypt from "@/utils/encrypt";
  import BannerApi from "@/api/admin/banner";
  import * as AWS from 'aws-sdk';

@Component({
  components: {
    CustomTable,
  },
})
export default class Member extends Vue {

  async s3(){
      let AWS = require('aws-sdk');
      AWS.config.region = 'ap-northeast-2'; // 리전
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'ap-northeast-2_jTxS5bJaz',
      });
      let s3 = new AWS.S3();
      return s3;
  };


  data: BannerModel[] = [];
  pagination: PaginationModel & { total?: number } = {
    current: 1,
    pageSize: 10,
    keyword: "",
    keywordType: "name",
    status:-1
  };

  datum: AdminModel = {
    name: "",
    password: "",
  };

  inputData = {
      code:"",
      titleImage:"",
      title:"",
      subTitle:"",
      sequence:1,
      status:1,
      type:"MAIN",
      url:"",
  };

  authData = { auth: "" };

  authentificate = false;
  modalLoading = false;
  visible = false;
  adminMode = false;
  loading = false;
  thumbnailFile: any= [];

  columns = [
    // {
    //   width: 100,
    //   title: "순서",
    //   dataIndex: "code",
    // },
    {
      width: 200,
      align: "left",
      title: "제목",
      dataIndex: "title",
      scopedSlots: { customRender: "title" },
    },
    {
      width: 150,
      align: "left",
      title: "내용",
      dataIndex: "subTitle",
      scopedSlots: { customRender: "subTitle" },
    },
    {
      width: 150,
      title: "이미지",
      align: "center",
      dataIndex: "titleImage",
      scopedSlots: { customRender: "titleImage" },
    },
    {
      width: 200,
      align: "left",
      title: "순서",
      dataIndex: "sequence",
      scopedSlots: { customRender: "sequence" },
    },
    {
      width: 200,
      align: "center",
      title: "노출여부",
      dataIndex: "status",
      scopedSlots: { customRender: "status" },
    },
    // {
    //   width: 100,
    //   align: "right",
    //   title: "동작",
    //   dataIndex: "action",
    //   scopedSlots: { customRender: "action" },
    // },
  ];


  selectItems: KeywordModel[] = [
    {
      value: "0",
      title: "미노출",
    },
    {
      value: "1",
      title: "노출",
    },
    
  ];

  showModal(data: any){
    if(data != "insert"){
      this.inputData = data;
      // this.inputData.eventTime = this.dateTimeFormat(data.eventTime);
    }else{
      this.inputData = {
        code:"",
        titleImage:"",
        type:"MAIN",
        title:"",
        subTitle:"",
        sequence:1,
        status:1,
        url:"",
      }
    }
    this.visible = true;
  }

  send() {
    AuthApi.SendCode();
  }

  canceled() {
    location.href = "/";
  }

  async auth() {
    const result = await AuthApi.Auth(this.authData.auth);
    this.authentificate = result.result;
    localStorage.setItem("auth", this.authentificate.toString());
  }

  moveOn(page: any) {
    this.pagination = page;
    this.load();
  }

  search() {
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  }

  toggle(checked: boolean, _: Event) {
    this.adminMode = checked;
    this.reset();
  }

  reset() {
    this.pagination = {
      ...this.pagination,
      current: 1,
      keyword: "",
      keywordType: "name",
      status: -1,
    };
    this.load();
  }

  pad2(n:any) { return n < 10 ? '0' + n : n }

  rowClick(record: any) {
      this.$router.push({ name: "memberDetail", query: { id: record.code , activeKey:"1"} });
  }

  async changeStatus(row:any, status:any) {

    let result = await BannerApi.changeStatus(row.code, status);
    if(result != null){
      row.status = result.status;
      this.$message.success(
        '변경 완료',
        10,
      );
    }else{
      this.$message.error(
        '오류가 발생했습니다. 관리자에게 문의해주세요.',
        10,
      );
    }
  }
  

  beforeUpload = (file: File) => {
      return false;
  };

  async uploadThumbnail(e : any){
      let imageFile = e.file;
      this.thumbnailFile = imageFile;
      this.inputData.titleImage = URL.createObjectURL(e.file);
  }

  async confirmDeleteBanner(){
      let res = confirm("해당 게시물을 정말 삭제하시겠습니까?");
      if(res){
          let result = await BannerApi.delete(this.inputData.code);
          if(result.result){
              location.reload();
          }else{
              alert("에러가 발생했습니다. 관리자에게 문의해주세요.");
          }
      }
  }


  async progress(row: any, activeKey: any){
      this.$router.push({ name: "memberDetail", query: { id: row.memberCode, activeKey: activeKey } });
  }

  async handleOk() {
    this.modalLoading = true;
    const model: AdminModel = {
      name: this.datum.name,
      password: Encrypt.hash(this.datum.password!),
    };
    await AdminApi.signup(model);
    this.load();
    this.resetDatum();
    this.modalLoading = false;
    this.visible = false;
  }

  async saveBanner(){


      if (this.inputData.titleImage.indexOf("blob:") >= 0) {
          let files = this.thumbnailFile;
      let file = files;
      let fileDot = file.name.lastIndexOf(".");
      let fileLength = file.name.length;
      let fileType = file.name.substring(fileDot+1,fileLength);
      let date = new Date();
      let titleP = date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2( date.getDate()) + this.pad2( date.getHours() ) + this.pad2( date.getMinutes() ) + this.pad2( date.getSeconds() );
      let albumPhotosKey = "banner/";
      let fileName = titleP + "." + fileType;
      let photoKey = albumPhotosKey + fileName;
      console.log("@@@@@@@@@@@@@");
      let AWS = require('aws-sdk');
      AWS.config.region = 'ap-northeast-2';
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'ap-northeast-2:e864059a-206b-444a-9d7f-68cc43db2084',
      });
      console.log("env, ", process.env.AWS_CONFIG)
      console.log("################");
      let s3 = new AWS.S3();

      let pd = this.inputData;

      await s3.upload({
              Bucket: "healland-lab/banner",
              Key: photoKey,
              Body: file,
              ACL: "public-read-write"
          },
          function(err :any , data : any) {
              if (err) {
                  console.log("what");
                  console.log(err);
              }
              let result;
              console.log("wy");
              pd.titleImage = data.Location;

              if(pd.code == ''){
                    result = BannerApi.save(pd);
              }else{
                  console.log(pd.status);
                  let param = {
                      "image":pd.titleImage,
                      "sequence": pd.sequence,
                      "status": 1,
                      "url":pd.url,
                  }
                    result = BannerApi.save(pd);
              }
              location.reload();
              //   router.go(0);
          });
      }
      else {
          let param = {
                  "image":this.inputData.titleImage,
                  "sequence": this.inputData.sequence,
                  "status": 1,
                  "url":this.inputData.url,
          }
          let result = BannerApi.save(this.inputData);
          location.reload();
              //   let result = Banner.Put(this.inputData.id,param);
              //   router.go(0);
          }
  }

  handleCancel() {
    this.visible = false;
    this.resetDatum();
  }

  handleChange(value: string) {
    this.pagination.keywordType = value;
  }

  resetDatum() {
    this.datum = {
      id: "",
      name: "",
    };
    this.reset();
  }

  mounted() {
    this.authentificate = localStorage.getItem("auth") === "true";
    this.load();
  }

  async load() {
    let result: any;
  result = await BannerApi.list("MAIN",this.pagination);
  console.log(result.data);
    this.data = [...result.data];
    this.pagination.total = result.totalCount;
  }

  edit(record: any) {
    this.visible = true;
    this.datum = {
      ...record,
    };
  }

  async remove(record: MemberModel) {
    await MemberApi.delete(record.id!);
    await this.load();
  }

}

interface KeywordModel {
  value: string;
  title: string;
}
